/**
 ** Login Logic:
 **
 ** 1) on Init: check if fields are set as required and enable/disable login button accordingly.
 **    If any field is set, mark missing/erroneous fields in red. Omit marking if all fields empty.
 **    Set focus on first noncompliant field.
 ** 2) On every keyup event check if fields are set as required. If ok, enable login button, if not, disable. No marking.
 ** 3) When tabbing out of a field (focuslost) check field compliance. Mark if not compliant (no focus)
 ** 4) on login click: same as Init but mark noncompliant fields in any case. Focus on first noncompliant field.
 **/

import delay from '../../utils/delay';

export default class widgetLoginChecker {
   constructor(controller) {
      this.controller = controller;
      this.ctl = {
         loginFirstName:   {req: true, regex: false},
         loginLastName:    {req: true, regex: false},
         loginEmail:       {req: false, regex: /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/},
      };
      // status for each field
      this.fstatus = {
      };
      // status if any field set - reset at checkAll, set at checkField
      this.cstatus = false;
      // field currently having the focus
      this.focus = undefined;
      this.init();
   }



   checkField(field, markinvalid) {
      let valid = false;
      if (this.ctl.hasOwnProperty(field)) {
         let val = this.controller.elements[field].val().trim();
         valid = (!this.ctl[field].req || !!val) && (!this.ctl[field].regex || !val || this.ctl[field].regex.test(val));
         this.fstatus[field] = valid;
         if (!!val) this.cstatus = true;
      }
      // unmark field if valid
      if (valid) this.mark(field, true);
      else if (markinvalid) this.mark(field, false);
      return valid;
   }

   checkAll() {
      let valid = true;
      this.cstatus = false;
      for (let field in this.ctl) {
         if (!this.checkField(field)) valid = false;
      }
      return valid;
   }

   allowSubmit() {
      let allow = !Object.keys(this.fstatus).some(field => !!!this.fstatus[field]);
      if (allow) {
         this.controller.elements['loginSubmitButton'].removeAttr('disabled');
      }
      else {
         this.controller.elements['loginSubmitButton'].attr('disabled', 'disabled');
      }
      return allow;
   }

   mark(field, ok) {
      if (ok) {
         this.controller.elements[field].closest(".cbot-inputContainer").removeClass('cbot-inputContainer--invalid');
      }
      else {
         this.controller.elements[field].closest(".cbot-inputContainer").addClass('cbot-inputContainer--invalid');
      }
   }

   init() {
      let self = this;

      // bind events
      Object.keys(this.ctl).map((field) => {
         self.controller.elements[field].on('keyup', delay(function(){self.keyup.call(self, field)}, 250));
         self.controller.elements[field].on('focus', function() {self.focus = field});
         self.controller.elements[field].on('blur',  function() {self.focuslost.call(self, field)});
         self.controller.elements[field].on('keypress', function(event) {self.keypress.call(self, event)});
      });

      // initial check and set login button
      (delay(function() {
         if (!self.allowSubmit(self.checkAll())) {
            // if not compliant and any field set, mark noncompliant fields and focus on first
            let focusset = false;
            for (let field in self.ctl) {
               if (!self.fstatus[field]) {
                  if (!focusset) {
                    var localIsMobile = function () {
                      var check = false;
                      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
                      return check;
                    }
                     if(!localIsMobile()) {
                      self.controller.elements[field].focus();
                     }
                     focusset = true;
                  }
                  if (self.cstatus) self.mark(field, false);
               }
            }
         }
      }, 250))();
  }

   keypress(event) {
      if (13 == event.keyCode) {
         this.controller.elements['loginSubmitButton'].trigger('click');
      }
   }

   keyup(field) {
      this.checkField(field, true);
      this.allowSubmit();
   }

   focuslost(field) {
      if (field == this.focus) {
         this.mark(field, this.checkField(field));
         this.focus = undefined;
      }
   }

   click() {
      let valid = this.checkAll();
      if (!valid) {
         Object.keys(this.fstatus).map(field => this.mark(field, this.fstatus[field]));
         Object.keys(this.fstatus).some(field => {if (!this.fstatus[field]) this.controller.elements[field].focus(); return !this.fstatus[field]});
      }
      return valid;
   }

   unbind() {
      // unbind bound handlers
     $('.cbot-login > *').off();
   }
}